import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-dispatcher',
    templateUrl: './dispatcher.component.html',
    styleUrls: ['./dispatcher.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatcherComponent implements OnInit
{
  ngOnInit() {
    this.selected = "dispatcher_table";
  }

  public selected: string;

  public select(name: string) {
    this.selected = name;
  }

  public isSelected(name: string) {
    return name == this.selected;
  }

}

